/**
 * Root layout — wraps the whole tree in the AuthProvider and renders the matched
 * route. Both the public auth routes and the gated app shell render under here,
 * so operator identity + sign-out are available everywhere.
 */
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';

export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
